"use client";
import { useContext } from "react";
import { IndicatorsContext } from "../../(context)/IndicatorsContext";
import { useThreeLevelSelector } from "./useThreeLevelSelector";
import { SearchArea } from "./SearchArea";
export const ThreeLevelSelector = () => {
  let {
    data,
    level1Value,
    level2Value,
    level3Value,
    dataSelector1,
    dataSelector2,
    dataSelector3,
  } = useContext(IndicatorsContext);

  let { handleOnChangeLevel1, handleOnChangeLevel2, handleOnChangeLevel3 } =
    useThreeLevelSelector();

  return (
    <>
      <div className="flex justify-end">
        <SearchArea data={data} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
        <label>
          <span className="text-2xl text-blue-800 font-bold">Primer Nivel</span>
          <select
            value={level1Value}
            onChange={(e) => handleOnChangeLevel1(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            {dataSelector1.map(({ label, index }) => (
              <option key={index} value={index}>
                {label}
              </option>
            ))}
          </select>
        </label>
        <label>
          <span className="text-2xl text-blue-800 font-bold">
            Segundo Nivel
          </span>
          <select
            value={level2Value}
            onChange={(e) => handleOnChangeLevel2(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            {dataSelector2.map(({ label, index }) => (
              <option key={index} value={index}>
                {label}
              </option>
            ))}
          </select>
        </label>
        <label>
          <span className="text-2xl text-blue-800 font-bold">Tercer Nivel</span>
          <select
            value={level3Value}
            onChange={(e) => handleOnChangeLevel3(e.target.value)}
            className="bg-gray-50 border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            {dataSelector3.map(({ label, index }) => (
              <option key={index} value={index}>
                {label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </>
  );
};
